import { IAcademicRepository } from '../../domain/repositories/IAcademicRepository';
import { LevelDTO } from '../dto/LevelDTO';
import { AcademicMapper } from '../mappers/AcademicMapper';

export class GetLevelsUseCase {
  constructor(private repository: IAcademicRepository) {}

  async execute(): Promise<LevelDTO[]> {
    const levels = await this.repository.getLevels();
    return AcademicMapper.levelToDTOList(levels);
  }
}
